<template>
    <div class="container">
        <br />
        <br />
        <div class="row justify-content-center mb-5">
            <div class="col-12">
                <router-link :to="backRoute">
                    <span class="icon icon-sm icon-glyphicons-basic-chevron-left mr-1 align-middle"></span>
                    <span class="align-middle">Back to Browse</span>
                </router-link>
            </div>
        </div>
        <div class="row" v-if="caseObj.id">
            <div class="col-12 mb-4 mb-lg-5 intro-action-container">
                <div class="d-flex flex-column flex-lg-row align-items-lg-center">
                    <div class="flex-grow-0 flex-shrink-0 mr-lg-5 mb-4 mb-lg-0">
                        <img
                            v-if="caseObj.cover_image"
                            :src="caseObj.cover_image.signed_img_urls.sm"
                            class="rounded-lg cover-image"
                            :alt="caseObj.cover_image_alt_text"
                        />
                        <div v-else class="cover-image d-flex w-100 h-100 align-items-center justify-content-center">
                            <span class="h5 mb-0 px-2 font-weight-bold text-center cover-placeholder">{{
                                caseObj.community_title
                            }}</span>
                        </div>
                        <div class="mt-3" style="min-height: 4px">
                            <community-case-progress-bar
                                v-if="activeSession"
                                :session="activeSession"
                                class="progress-container"
                            ></community-case-progress-bar>
                        </div>
                        <div class="mt-1" v-if="activeSession">
                            <span
                                v-show="activeSession.successful"
                                class="badge badge-success align-middle complete-text"
                            >
                                Successful
                            </span>
                        </div>
                    </div>
                    <div class="flex-grow-1 mb-4">
                        <div class="mb-4 mb-lg-2">
                            <div class="mb-3 d-flex align-items-center">
                                <span class="font-weight-bold small uppercase text-secondary align-middle top-icon">
                                    <span class="icon-lg icon-glyphicons-basic-clock mr-1 align-middle"></span>
                                    <span class="align-middle"
                                        >{{ caseObj.duration }} {{ caseObj.duration_units }}</span
                                    >
                                </span>
                                <span
                                    v-if="caseObj.community_is_featured"
                                    class="badge badge-success-highlight align-middle"
                                    >Featured</span
                                >
                                <span v-else-if="caseObj.community_is_new" class="badge badge-highlight align-middle"
                                    >New</span
                                >
                            </div>
                            <h1 class="h6 mb-2">
                                <span class="align-middle">{{ caseObj.community_title }}</span>
                                <span class="align-middle badge badge-gray ml-2" v-if="caseObj.ui_language != 'en'">
                                    <span class="icon icon-glyphicons-basic-globe mr-xs"></span>
                                    <span>{{ caseObj.ui_language }}</span>
                                </span>
                            </h1>
                            <p class="text-secondary mb-3 community-text-body">{{ caseObj.community_description }}</p>
                        </div>
                        <div class="pt-1 d-flex align-items-center flex-wrap" style="margin-bottom: 20px">
                            <button @click="openShare(caseObj)" class="btn btn-gray mr-2 mb-2 mb-lg-0" type="button">
                                <span class="icon icon-glyphicons-basic-link icon-mr"></span>
                                <span>Share</span>
                            </button>
                            <!-- <button
                                @click="openEmbed(caseObj)"
                                class="btn btn-gray mr-2 mb-2 mb-lg-0"
                                type="button"
                                aria-label="Open embed code"
                            >
                                <span class="icon icon-glyphicons-basic-code mr-2"></span>
                                <span>Embed</span>
                            </button> -->
                            <button
                                @click="openAddModal()"
                                class="btn btn-gray mr-2 mb-2 mb-lg-0"
                                type="button"
                                aria-label="Open add-to-library dialog"
                            >
                                <span class="icon icon-100 icon-glyphicons-basic-plus align-middle"></span>
                            </button>
                            <button
                                v-if="!activeSession"
                                @click="startSession(caseObj)"
                                class="btn btn-brand mr-2 mb-2 mb-lg-0"
                                :disabled="loading"
                                type="button"
                            >
                                <span class="icon icon-glyphicons-basic-play icon-mr"></span>
                                <span>Start</span>
                            </button>
                            <button
                                v-if="activeSession"
                                @click="openRestart(caseObj)"
                                class="btn btn-gray mr-2 mb-2 mb-lg-0"
                                :disabled="loading"
                                type="button"
                            >
                                <span class="icon icon-glyphicons-basic-restart icon-mr"></span>
                                <span>Restart</span>
                            </button>
                            <div>
                                <router-link
                                    :to="sessionRouteObj(caseObj)"
                                    class="btn btn-brand mr-2 mb-2 mb-lg-0"
                                    :disabled="loading"
                                    type="button"
                                    v-if="activeSession"
                                >
                                    <span class="icon icon-glyphicons-basic-play icon-mr"></span>
                                    <span>Resume</span>
                                </router-link>
                            </div>
                            <div class="ml-3 small" v-if="addedToLibrary && addedToOrg">
                                <span
                                    class="icon icon-100 align-middle text-success icon-glyphicons-basic-circle-check"
                                ></span>
                                <span class="text-secondary align-middle">
                                    Added to
                                    <span class="font-weight-bold">{{ addedToOrg.name }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="d-flex align-items-center" style="margin-bottom: 10px">
                            <div v-show="caseObj.community_tags.length > 0" style="margin-right: 18px">
                                <community-category-tags :tags="caseObj.community_tags"></community-category-tags>
                            </div>
                            <div class="text-secondary small">
                                <span class="icon icon-glyphicons-basic-trending icon-mr"></span>
                                <span class="mb-0 font-weight-500"
                                    >{{ formatViewCount(caseObj.view_count) }} Views</span
                                >
                            </div>
                        </div>
                        <div class="mb-2">
                            <span class="text-secondary font-weight-500 small mr-1"
                                >Freely-usable under Creative Commons
                                <a :href="creativeCommonsUrl" target="_blank" rel="noopener">CC BY-SA</a></span
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 community-info-container">
                <div v-for="field in displayFields" :key="field.header">
                    <div v-show="displaySection(field.propertyName)">
                        <div class="mb-4">
                            <h2 class="mb-3 font-weight-bold form-divider-label detail-subheader community-text-body">
                                <span class="icon mr-1 align-middle detail-header-glyph" :class="[field.glyph]"></span>
                                <span class="align-middle">{{ field.header }}</span>
                            </h2>
                            <div v-if="field.header == 'CREATORS'">
                                <div class="d-flex">
                                    <div
                                        class="d-flex align-items-center mr-1"
                                        v-for="contributor in caseObj.contributors"
                                        :key="contributor.id"
                                    >
                                        <info-popover :content="contributor.publisher.name" placement="top">
                                            <router-link
                                                :to="publisherDetailRouteObj(contributor.publisher)"
                                                class="flex-grow-0 logo-container logo-md rounded-circle d-flex align-items-center mr-2"
                                            >
                                                <img
                                                    :src="contributor.publisher.logo_file.signed_img_urls.thumb"
                                                    class="logo-circle"
                                                    :alt="contributor.publisher.name + ' Logo'"
                                                />
                                            </router-link>
                                        </info-popover>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="field.propertyName == 'community_files'">
                                <div class="d-flex flex-wrap">
                                    <div
                                        v-for="communityFile in caseObj.community_files"
                                        :key="communityFile.id"
                                        class="flex-grow-0 card rounded mr-2"
                                    >
                                        <div class="px-3 py-2 bg-white rounded">
                                            <a
                                                :href="communityFile.stored_file.signed_url"
                                                rel="noopener"
                                                target="_blank"
                                            >
                                                <span
                                                    class="align-middle icon icon-glyphicons-basic-cloud-download mr-2"
                                                ></span>
                                                <span class="align-middle">{{ communityFile.name }}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="field.propertyName == 'versions'">
                                <div class="pt-1 community-text-body">
                                    <div v-for="packageCase in caseObj.package_cases" :key="packageCase.id">
                                        <div class="d-flex flex-column flex-lg-row align-items-lg-center mb-4">
                                            <div class="flex-grow-0 flex-shrink-0 mr-lg-4 pr-lg-3 mb-4 mb-lg-0">
                                                <img
                                                    :src="packageCase.cover_image.signed_url"
                                                    class="rounded-lg cover-image-sm"
                                                    :alt="packageCase.cover_image_alt_text"
                                                />
                                                <div v-if="packageCase.session" class="mt-3" style="min-height: 4px">
                                                    <community-case-progress-bar
                                                        :session="packageCase.session"
                                                        class="progress-container-sm"
                                                    ></community-case-progress-bar>
                                                </div>
                                            </div>
                                            <div class="flex-grow-1">
                                                <h2 class="h6 mb-2">
                                                    <span class="align-middle">{{ packageCase.community_title }}</span>
                                                    <span
                                                        class="align-middle badge badge-gray ml-2"
                                                        v-if="packageCase.ui_language != 'en'"
                                                    >
                                                        <span
                                                            class="icon icon-glyphicons-basic-globe language-icon"
                                                        ></span>
                                                        <span>{{ packageCase.ui_language }}</span>
                                                    </span>
                                                </h2>
                                                <p class="text-secondary mb-3">
                                                    {{ packageCase.community_description }}
                                                </p>
                                                <div
                                                    class="mb-4"
                                                    :class="{
                                                        'mb-lg-3': packageCase.session,
                                                        'mb-lg-0': !packageCase.session,
                                                    }"
                                                >
                                                    <button
                                                        @click="openShare(packageCase)"
                                                        class="btn btn-sm btn-gray mr-2"
                                                        type="button"
                                                    >
                                                        <span class="icon icon-glyphicons-basic-link icon-mr"></span>
                                                        <span>Share</span>
                                                    </button>
                                                    <button
                                                        @click="openEmbed(packageCase)"
                                                        class="btn btn-sm btn-gray mr-2"
                                                        type="button"
                                                    >
                                                        <span class="icon icon-glyphicons-basic-code"></span>
                                                    </button>
                                                    <button
                                                        v-if="packageCase.session && packageCase.session.id"
                                                        @click="openRestart(packageCase)"
                                                        class="btn btn-sm btn-gray mr-2"
                                                        :disabled="loading"
                                                        type="button"
                                                    >
                                                        <span class="icon icon-glyphicons-basic-restart icon-mr"></span>
                                                        <span>Restart</span>
                                                    </button>
                                                    <button
                                                        v-if="!(packageCase.session && packageCase.session.id)"
                                                        @click="startSession(packageCase)"
                                                        class="btn btn-sm btn-brand"
                                                        :disabled="loading"
                                                        type="button"
                                                    >
                                                        <span class="icon icon-glyphicons-basic-play icon-mr"></span>
                                                        <span>Start</span>
                                                    </button>
                                                    <router-link
                                                        :to="sessionRouteObj(packageCase)"
                                                        class="btn btn-sm btn-brand"
                                                        :disabled="loading"
                                                        type="button"
                                                        v-if="packageCase.session && packageCase.session.id"
                                                    >
                                                        <span class="icon icon-glyphicons-basic-play icon-mr"></span>
                                                        <span>Resume</span>
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p v-else class="community-info community-text-body">{{ caseObj[field.propertyName] }}</p>
                        </div>
                        <hr />
                    </div>
                </div>
                <p class="text-secondary small mt-4 mb-2">
                    This open educational resource was last updated on {{ formatDate(caseObj.last_modified) }}.
                </p>
            </div>
        </div>
        <!-- Share Modal -->
        <base-modal id="share-modal" :centered="true">
            <template slot="title">
                <span class="icon icon-glyphicons-basic-link mr-1"></span>
                <span>Share</span>
            </template>
            <template>
                <div class="mb-2">
                    <p class="text-secondary">Share this scenario with anyone using the link below:</p>
                    <copy-link-input ref="copyShareLink" v-model="selectedShareLink"></copy-link-input>
                    <div class="custom-control custom-checkbox pb-1 mt-3">
                        <input
                            v-model="usePlayLink"
                            id="usePlayLink"
                            type="checkbox"
                            class="custom-control-input"
                            @click="$refs.copyShareLink.reset()"
                        />
                        <label class="custom-control-label" for="usePlayLink">
                            <span class="pr-1">Launch directly into scenario</span>
                            <help-text
                                content="Check this box if you want recipients of this link to launch directly into this scenario instead of seeing this page."
                            ></help-text>
                        </label>
                    </div>
                </div>
            </template>
        </base-modal>
        <!-- Embed Modal -->
        <base-modal id="embed-modal" :centered="true">
            <template slot="title">
                <span class="icon icon-glyphicons-basic-code mr-2"></span>
                <span>Embed Code</span>
            </template>
            <template>
                <p v-if="selectedCase" class="text-secondary medium">
                    Embed this snippet into your website or learning management system:
                </p>
                <copy-link-input
                    ref="copyEmbedLink"
                    v-model="selectedCaseEmbedCode"
                    copy-btn-label="Copy"
                    success-message="Embed code copied to clipboard"
                    class="mb-2"
                ></copy-link-input>
            </template>
        </base-modal>
        <!-- Restart Modal -->
        <base-modal id="restart-modal" :centered="true">
            <template slot="title">
                <span class="icon icon-glyphicons-basic-restart mr-1"></span>
                <span>Restart Scenario</span>
            </template>
            <template>
                <p v-if="selectedCase" class="my-2">
                    Restart <strong>{{ selectedCase.community_title }}</strong
                    >?
                </p>
            </template>
            <template slot="footer">
                <button class="btn btn-secondary" type="button" data-dismiss="modal">Close</button>
                <button @click="restartCase(selectedCase)" class="btn btn-brand" type="button">
                    <span class="icon icon-glyphicons-basic-restart icon-mr"></span>
                    <span>Restart</span>
                </button>
            </template>
        </base-modal>
        <!-- Add to Library Modal -->
        <community-add-modal
            :case-obj="caseObj"
            v-on:added-to-library="markAsAdded($event)"
            ref="communityAddModal"
        ></community-add-modal>
    </div>
</template>

<script>
import CopyLinkInput from "@/components/CopyLinkInput"
import CommunityCategoryTags from "@/components/CommunityCategoryTags"
import CommunityCaseProgressBar from "@/components/CommunityCaseProgressBar"
import CommunityAddModal from "@/components/CommunityAddModal"
import http from "@/axios.js"
import Utilities from "@/assets/js/utilities.js"
import BaseModal from "@/components/BaseModal"
import HelpText from "@/components/HelpText"
import InfoPopover from "@/components/InfoPopover"

export default {
    name: "CommunityCaseDetail",
    components: {
        CommunityCategoryTags,
        CommunityCaseProgressBar,
        BaseModal,
        HelpText,
        CopyLinkInput,
        InfoPopover,
        CommunityAddModal,
    },
    data() {
        return {
            caseObj: {
                package_cases: [],
                community_tags: [],
                session: null,
            },
            activeSession: null,
            selectedCase: {},
            usePlayLink: false,
            displayFields: [
                {
                    header: "ABOUT",
                    glyph: "icon-glyphicons-basic-circle-info",
                    propertyName: "community_about",
                },
                {
                    header: "CREATORS",
                    glyph: "icon-glyphicons-basic-education",
                },
                {
                    header: "VERSIONS & LEVELS",
                    glyph: "icon-glyphicons-basic-squares",
                    propertyName: "versions",
                },
                {
                    header: "TARGET AUDIENCE",
                    glyph: "icon-glyphicons-basic-user-group",
                    propertyName: "target_audience",
                },
                {
                    header: "LEARNING OBJECTIVES",
                    glyph: "icon-glyphicons-basic-square-checkbox",
                    propertyName: "learning_objectives",
                },
                {
                    header: "FILES",
                    glyph: "icon-glyphicons-basic-paperclip",
                    propertyName: "community_files",
                },
                {
                    header: "AUTHORS",
                    glyph: "icon-glyphicons-basic-feather",
                    propertyName: "creators_credit",
                },
                {
                    header: "PROJECT FUNDING",
                    glyph: "icon-glyphicons-basic-dollar",
                    propertyName: "funding",
                },
            ],
            addedToLibrary: false,
            addedToOrg: null,
        }
    },
    computed: {
        caseID() {
            return this.$route.params.id
        },
        loading() {
            return this.$store.getters.loading
        },
        creativeCommonsUrl() {
            return this.$store.getters.creativeCommonsLicenseUrl
        },
        userIsAnonymous() {
            return this.$store.getters.userIsAnonymous
        },
        selectedShareLink() {
            if (this.usePlayLink) {
                return this.playLink
            }
            return this.shareLink
        },
        selectedCaseEmbedCode() {
            return `<iframe src="${this.playLink}" width="100%" height="900" style="max-width: 100%; max-height: 100%; border-radius: 8px" frameborder="0" frameborder="0" allowfullscreen></iframe>`
        },
        shareLink() {
            return `${window.location.origin}/community/browse/${this.selectedCase.id}`
        },
        playLink() {
            return `${window.location.origin}/community/play/${this.selectedCase.id}`
        },
        playRoute() {
            return `/community/play/${this.selectedCase.id}`
        },
        backToCategory() {
            let currentCategory = this.$store.getters.communityLibraryCategory
            if (currentCategory === undefined && this.caseObj.community_tags.length) {
                // If there's at least one category tag, route back to the first category listed.
                // Route the user back to the library category they came from.
                return this.caseObj.community_tags[0].category.name
            }
            return currentCategory
        },
        backRoute() {
            let route = { name: "CommunityLibrary" }
            if (this.backToCategory) {
                route["query"] = {
                    tag: this.backToCategory,
                }
            }
            return route
        },
    },
    methods: {
        async fetchData() {
            this.$store.dispatch("addLoad")
            let vm = this

            // Fetch details about the case being viewed.
            await http.get(`/api/community/cases/browse/${this.caseID}/`).then(function (response) {
                vm.caseObj = response.data
                if (response.data.active_session && response.data.active_session.id) {
                    vm.activeSession = response.data.active_session
                }
            })

            await this.$store.dispatch("fetchAuth")
            vm.$store.dispatch("removeLoad")
            if (!this.userIsAnonymous && this.caseObj.package_cases.length) {
                let packageCaseIds = this.caseObj.package_cases.map((c) => c.id)
                // Fetch any active session that the user has for the case.
                http.get("/api/community/sessions/", {
                    params: {
                        caseIds: JSON.stringify(packageCaseIds),
                    },
                }).then(function (response) {
                    let relatedSessions = response.data
                    // Attach the
                    vm.caseObj.package_cases.forEach((packageCase) => {
                        vm.$set(
                            packageCase,
                            "session",
                            relatedSessions.find((s) => s.case.id == packageCase.id)
                        )
                    })
                })
            }
        },
        formatDate(dateStr) {
            return Utilities.formatDate(dateStr)
        },
        openShare(caseObj) {
            this.selectedCase = caseObj
            this.$refs.copyShareLink.reset()
            $("#share-modal").modal("show")
        },
        openEmbed(caseObj) {
            this.selectedCase = caseObj
            this.$refs.copyEmbedLink.reset()
            $("#embed-modal").modal("show")
        },
        openRestart(caseObj) {
            this.selectedCase = caseObj
            $("#restart-modal").modal("show")
        },
        restartCase(caseObj) {
            $("#restart-modal").modal("hide")
            this.startSession(caseObj, true)
        },
        publisherDetailRouteObj(publisher) {
            return {
                name: "CommunityPublisherDetail",
                params: {
                    id: publisher.id,
                },
            }
        },
        startSession(caseObj, forceRestart = false) {
            this.selectedCase = caseObj
            if (this.userIsAnonymous) {
                if (forceRestart) {
                    window.location = this.playRoute + "?forceRestart=true"
                } else {
                    window.location = this.playRoute
                }
                return
            } else {
                this.$store.dispatch("addLoad")
                let vm = this
                http.post(`/api/community/cases/${caseObj.id}/start/`)
                    .then(function (response) {
                        vm.$store.dispatch("removeLoad")
                        vm.$router.push({
                            name: "CommunityCaseSession",
                            params: {
                                caseID: String(caseObj.id),
                                sessionID: String(response.data.session_id),
                            },
                        })
                    })
                    .finally(function () {
                        vm.$store.dispatch("removeLoad")
                    })
            }
        },
        sessionRouteObj(caseObj) {
            if (!this.activeSession) {
                return null
            }
            return {
                name: "CommunityCaseSession",
                params: { caseID: String(caseObj.id), sessionID: String(this.activeSession.id) },
            }
        },
        displaySection(propertyName) {
            if (propertyName == "versions") {
                return this.caseObj.package_cases.length > 0
            } else if (propertyName == "community_files") {
                return this.caseObj.community_files.length > 0
            } else {
                return this.caseObj[propertyName] != ""
            }
        },
        formatViewCount(count) {
            return Utilities.formatViewCount(count)
        },
        openAddModal() {
            this.$refs.communityAddModal.open()
        },
        markAsAdded(organization) {
            this.addedToLibrary = true
            this.addedToOrg = organization
        },
    },
    mounted() {
        this.fetchData()
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/community.scss";

$cover-height: 240px;
$cover-width: 380px;
$cover-sm-ratio: 0.65;

.cover-image {
    max-width: 100%;
    height: $cover-height;
    width: $cover-width;
    object-fit: cover;
}

.cover-image-sm {
    max-width: 100%;
    height: $cover-height * $cover-sm-ratio;
    width: $cover-width * $cover-sm-ratio;
    object-fit: cover;
}

.progress-container-sm {
    max-width: $cover-width * $cover-sm-ratio;
}

.progress-container {
    max-width: $cover-width;
}

.ol {
    padding-inline-start: 0px;
    li {
        list-style-type: none;
    }
}

ul {
    margin-bottom: 0px;
    padding-inline-start: 0px;
    li {
        list-style-type: none;
    }
}

.intro-action-container {
    max-width: 1180px;
}

.btn {
    white-space: nowrap;
}

.top-icon {
    margin-right: 16px;
}
</style>